import { render, staticRenderFns } from "./AddNewVirtualServerPackageModal.vue?vue&type=template&id=6ba0646e&"
import script from "./AddNewVirtualServerPackageModal.vue?vue&type=script&lang=js&"
export * from "./AddNewVirtualServerPackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports